// @flow
import * as React from 'react';
import NumberInput from 'esm-web-pro/components/forms/fields/NumberInput';
import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Stack } from 'grommet';

type Props = {
    pointKey: string,
    onChange: Function,
    number: number,
}

const CableReserveField = (props: Props) => {
    const {
        onChange, number, pointKey: key,
    } = props;

    return (
        <Field
            name={key}
            key={key}
        >
            {
                (field: FieldProps) => (
                    <Stack interactiveChild="first">
                        <NumberInput
                            label={(
                                <FormattedMessage
                                    id="cable-reserve-field"
                                    defaultMessage="Cable Reserve for Point {reserve}"
                                    values={{
                                        reserve: number,
                                    }}
                                />
                            )}
                            required
                            min_value={0}
                            {...field}
                            defaultValue="0"
                            field={{
                                ...field.field,
                                onChange: (e) => {
                                    onChange(e.target.value);
                                    field.field.onChange(e);
                                },
                            }}
                            unit="м."
                        />
                    </Stack>
                )
            }
        </Field>
    );
};

export default CableReserveField;
